import { createContext, useContext } from 'react';

const Ctx = createContext(null);
export const GstProvider = Ctx.Provider;
export const useGst = () => useContext(Ctx);
